import { Button, CardActions, Chip, Stack, Typography, Grid, Divider, Box, Input, CardHeader } from '@mui/material';
import MainCard from './MainCard';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useTheme } from '@mui/material/styles';
import { handleAlertMessage, handleAsyncCall, toDefaultDateFormat } from 'utils/common';
import { micService } from 'services/mic';
import PicDispose from 'assets/images/layer-enhancement/pic_dispose.png';
import useMain from 'hooks/useMain';
import { useEffect, useRef, useState } from 'react';
import CusDrawer from './CusDrawer';
import { SidebarForm } from 'pages/module/component';
import { detailsWorkflowFields } from 'pages/module/field';
import _ from 'lodash';
import moment from 'moment';
import CusAuditCard from './CusAuditCard';
import ModeIcon from '@mui/icons-material/Mode';
import ViewTimelineOutlinedIcon from '@mui/icons-material/ViewTimelineOutlined';
import CusListLabelField from './CusListLabelField';
import { Button1, Button2, Button4 } from './Button';
import CusFormField from './CusFormField';
import OutlinedInput from 'themes/overrides/OutlinedInput';
import CusModal from './CusModal';
import { useForm } from 'react-hook-form';
import { BC_TYPE } from 'pages/module/constant';

const CusDetailSummary = ({ details, detailId, fetchDetail, fields, currentBctype }) => {
  const { t, upperCaseLang } = useMain();
  const [openModal, setOpenModal] = useState();
  const theme = useTheme();

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();

  useEffect(() => {
    reset({
      LicensePlateNo: details?.LicensePlateNo === 'NA' ? null : details?.LicensePlateNo,
      SubstitutedDate: null
    });
  }, [openModal]);

  return (
    <MainCard sx={{ overflow: 'visible' }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ width: 1 }}>
        <Stack direction="row">
          <Typography variant="h5" sx={{ color: theme.palette.primary[400], marginRight: '8px' }}>
            {t('DETAIL')}
          </Typography>
          {!!details?.Dispose && (
            <Chip
              sx={{
                bgcolor: '#fae8e8',
                borderRadius: '11px',
                color: '#ff6060'
              }}
              size="small"
              label={
                <Typography variant="body2" fontWeight={600}>
                  {t('DISPOSED')}
                </Typography>
              }
            />
          )}
        </Stack>
        <Stack direction="row" columnGap={1}>
          {currentBctype === BC_TYPE.MIC && (
            <Button1
              disabled={!!details?.Dispose}
              text={t('VEHICLE_SUBSTITUTION')}
              onClick={() => {
                setOpenModal(true);
              }}
            />
          )}

          <Button4
            text={t('DISPOSE')}
            disabled={!!details?.Dispose}
            // variant="contained"
            onClick={() => {
              const params = {
                StepCode: `${currentBctype}${1}`,
                Data: { ...details, Id: detailId, Dispose: 1 }
              };
              handleAlertMessage({
                title: `${t('CONFIRM_MIC_DISPOSE')}?`,
                confirmButtonText: t('BTN_DISPOSE'),
                cancelButtonText: t('BTN_CANCEL'),
                cb: (r) => {
                  if (r?.isConfirmed) {
                    handleAsyncCall({
                      // service: micService.modifyRfidStepDetails,
                      service: micService.dispoeRfidDetails,
                      params: detailId,
                      title: t(''),
                      successCb: (res) => {
                        fetchDetail();
                        setOpenSidebar(false);
                        handleAlertMessage({
                          text: t('MIC_DISPOSED'),
                          imageUrl: PicDispose,
                          imageAlt: 'dispose iamge',
                          showCancelButton: false
                        });
                      }
                    });
                  }
                }
              });
            }}
            startIcon={<DeleteOutlineIcon />}
          />
        </Stack>
      </Stack>

      {details && (
        <CusListLabelField data={details} fields={fields} fieldKey={'id'} xs={12} sm={4} md={4} labelFieldKeyPrefix={'summary-labeField'} />
      )}
      <CusModal
        open={openModal}
        setOpen={setOpenModal}
        sx={{ width: '25vw', minWidth: '300px' }}
        title={t('VEHICLE_SUBSTITUTION')}
        content={
          <form
            onSubmit={handleSubmit(async (d) => {
              const { LicensePlateNo, SubstitutedDate } = d;

              await handleAsyncCall({
                showSuccessAlert: true,
                // service: micService.modifyRfidStepDetails,
                service: micService.substituteVehicle,
                params: {
                  rfidmoduleid: detailId,
                  data: {
                    LicensePlateNo: LicensePlateNo ?? 'NA',
                    SubstitutedDate: moment(SubstitutedDate).format('YYYY-MM-DDTHH:mm:ss')
                  }
                },
                successCb: (res) => {
                  fetchDetail();
                  setOpenSidebar(false);
                }
              });

              setOpenModal(false);
            })}
          >
            <Stack rowGap={2}>
              <CusFormField
                id="LicensePlateNo"
                label={t('LICENSE_PLATE_NO')}
                control={control}
                colProps={{
                  md: 12
                }}
                showClear
              />
              <CusFormField
                id="SubstitutedDate"
                label={t('SUBSTITUTED_DATE')}
                type="dateTimePicker"
                control={control}
                cProps={{
                  rules: {
                    required: true
                  }
                }}
                fieldProps={{
                  slotProps: {
                    textField: {
                      error: !!errors?.SubstitutedDate
                    }
                  }
                }}
                colProps={{
                  md: 12
                }}
              />

              <Button1 text={t('CONFIRM')} type="submit" color="primary" />
              <Button2 text={t('BTN_CANCEL')} onClick={() => setOpenModal(false)} />
            </Stack>
          </form>
        }
      />
    </MainCard>
  );
};

export default CusDetailSummary;
